import { GRANT_TYPE } from '../config/keycloak_enums';
import { authData, keycloakError } from '../stores/stores';
const client_id = process.env.CLIENT_ID;
const auth_url = process.env.AUTH_URL;
const client_secret = process.env.CLIENT_SECRET;
export async function apiLogin() {
    const data = new URLSearchParams({
        grant_type: GRANT_TYPE.CLIENT_CREDENTIALS,
        client_id: client_id,
        client_secret: client_secret
    });
    //POST request with body equal on data in JSON format
    await fetch(auth_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data.toString()
    })
        .then(response => response.json())
        .then(data => {
        const authInstance = {
            accessToken: data === null || data === void 0 ? void 0 : data.access_token,
            expiresInToken: data === null || data === void 0 ? void 0 : data.expires_in,
            refreshToken: data === null || data === void 0 ? void 0 : data.refresh_token,
            expiresInRefreshToken: data === null || data === void 0 ? void 0 : data.refresh_expires_in,
            createdDate: new Date().valueOf()
        };
        keycloakError.set(false);
        authData.set(authInstance);
    })
        .catch(error => {
        keycloakError.set(true);
        console.error('Error:', error);
    });
}
export async function getTokenfromRefreshToken(auth) {
    var _a;
    const refresh = (_a = auth.refreshToken) !== null && _a !== void 0 ? _a : auth.refreshToken;
    if (refresh) {
        const data = new URLSearchParams({
            grant_type: GRANT_TYPE.REFRESH_TOKEN,
            client_id: client_id,
            client_secret: client_secret,
            refresh_token: refresh
        });
        await fetch(auth_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: data.toString()
        })
            .then(response => response.json())
            .then(data => {
            const authInstance = {
                accessToken: data === null || data === void 0 ? void 0 : data.access_token,
                expiresInToken: data === null || data === void 0 ? void 0 : data.expires_in,
                refreshToken: data === null || data === void 0 ? void 0 : data.refresh_token,
                expiresInRefreshToken: data === null || data === void 0 ? void 0 : data.refresh_expires_in,
                createdDate: new Date().valueOf()
            };
            keycloakError.set(false);
            authData.set(authInstance);
        })
            .catch(error => {
            keycloakError.set(true);
            console.error('Error:', error);
        });
    }
}
export function isInTime(verifyToken, auth) {
    var _a;
    const accessToken = (_a = auth.accessToken) !== null && _a !== void 0 ? _a : auth.accessToken;
    if (accessToken) {
        const receiveTokenTime = auth.createdDate;
        let expireTime;
        if (verifyToken) {
            expireTime = auth.expiresInToken;
        }
        else {
            expireTime = auth.expiresInRefreshToken;
        }
        const duration = new Date().valueOf() / 1000 - receiveTokenTime.valueOf() / 1000;
        return duration < expireTime - 10;
    }
    else {
        return false;
    }
}
export async function recoverToken(auth) {
    if (auth.accessToken === undefined) {
        await apiLogin();
    }
    if (!isInTime(true, auth)) {
        if (isInTime(false, auth)) {
            await getTokenfromRefreshToken(auth);
        }
        else {
            await apiLogin();
        }
    }
}
